'use client';

import React, { useEffect, useRef } from 'react';
import Icon from '@/components/ui/AppIcon';

const reasons = [
  {
    icon: 'AcademicCapIcon',
    title: 'PCI & BTE Accredited',
    description:
      'Fully approved by the Pharmacy Council of India and Board of Technical Education, ensuring nationally recognised qualifications.',
    year: '2001',
  },
  {
    icon: 'BeakerIcon',
    title: 'Advanced Research Facilities',
    description:
      'Cutting-edge laboratories equipped with analytical instruments for hands-on pharmaceutical research and drug development.',
    year: '2005',
  },
  {
    icon: 'UserGroupIcon',
    title: 'Expert Faculty',
    description:
      'Over 80 experienced educators and industry practitioners dedicated to mentoring and developing every student\'s potential.',
    year: '2008',
  },
  {
    icon: 'BriefcaseIcon',
    title: 'Industry Placements',
    description:
      'A dedicated placement cell with ties to top pharmaceutical companies, hospitals, and research organisations across India.',
    year: '2012',
  },
  {
    icon: 'HeartIcon',
    title: 'Student Welfare',
    description:
      'Anti-ragging cell, gender sensitisation, sports facilities, and comprehensive counselling support for holistic development.',
    year: '2015',
  },
  {
    icon: 'GlobeAltIcon',
    title: 'Industry Connections',
    description:
      'Regular industrial visits, workshops, and seminars with leading pharmaceutical companies and healthcare institutions.',
    year: '2018',
  },
];

export default function WhyChooseUs() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const cards = entry.target.querySelectorAll<HTMLElement>('.why-card');
            cards.forEach((card, i) => {
              card.style.transitionDelay = `${i * 0.1}s`;
              card.style.opacity = '1';
              card.style.transform = 'translateY(0)';
            });
            observer.disconnect();
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section data-component-id="src/app/components/WhyChooseUs.tsx:76:4" data-component-path="src/app/components/WhyChooseUs.tsx" data-component-line="76" data-component-end-line="122" data-component-file="WhyChooseUs.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22py-20%20md%3Apy-28%20px-6%20bg-muted%22%7D"
      ref={sectionRef}
      className="py-20 md:py-28 px-6 bg-muted"
    >
      <div data-component-id="src/app/components/WhyChooseUs.tsx:80:6" data-component-path="src/app/components/WhyChooseUs.tsx" data-component-line="80" data-component-end-line="121" data-component-file="WhyChooseUs.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%22%7D" className="max-w-7xl mx-auto">
        <div data-component-id="src/app/components/WhyChooseUs.tsx:81:8" data-component-path="src/app/components/WhyChooseUs.tsx" data-component-line="81" data-component-end-line="91" data-component-file="WhyChooseUs.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-2xl%20mb-14%22%7D" className="max-w-2xl mb-14">
          <span data-component-id="src/app/components/WhyChooseUs.tsx:82:10" data-component-path="src/app/components/WhyChooseUs.tsx" data-component-line="82" data-component-end-line="82" data-component-file="WhyChooseUs.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22section-label%20block%20mb-3%22%2C%22textContent%22%3A%22Why%20Shri%20R.%20P.%20College%20of%20Pharmacy%22%7D" className="section-label block mb-3">Why Shri R. P. College of Pharmacy</span>
          <h2 data-component-id="src/app/components/WhyChooseUs.tsx:83:10" data-component-path="src/app/components/WhyChooseUs.tsx" data-component-line="83" data-component-end-line="86" data-component-file="WhyChooseUs.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-display%20text-foreground%22%2C%22textContent%22%3A%22Built%20for%22%7D" className="text-display text-foreground">
            Built for{' '}
            <em data-component-id="src/app/components/WhyChooseUs.tsx:85:12" data-component-path="src/app/components/WhyChooseUs.tsx" data-component-line="85" data-component-end-line="85" data-component-file="WhyChooseUs.tsx" data-component-name="em" data-component-content="%7B%22elementName%22%3A%22em%22%2C%22className%22%3A%22font-normal%20italic%20text-primary%22%2C%22textContent%22%3A%22Academic%20Excellence%22%7D" className="font-normal italic text-primary">Academic Excellence</em>
          </h2>
          <p data-component-id="src/app/components/WhyChooseUs.tsx:87:10" data-component-path="src/app/components/WhyChooseUs.tsx" data-component-line="87" data-component-end-line="90" data-component-file="WhyChooseUs.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-muted-foreground%20mt-4%20leading-relaxed%22%2C%22textContent%22%3A%22More%20than%20two%20decades%20of%20commitment%20to%20pharmaceutical%20education%2C%20research%2C%5Cn%20%20%20%20%20%20%20%20%20%20%20%20and%20student%20success.%22%7D" className="text-muted-foreground mt-4 leading-relaxed">
            More than two decades of commitment to pharmaceutical education, research,
            and student success.
          </p>
        </div>

        <div data-component-id="src/app/components/WhyChooseUs.tsx:93:8" data-component-path="src/app/components/WhyChooseUs.tsx" data-component-line="93" data-component-end-line="120" data-component-file="WhyChooseUs.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20sm%3Agrid-cols-2%20lg%3Agrid-cols-3%20gap-6%22%7D" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((reason, i) => (
            <div data-component-id="src/app/components/WhyChooseUs.tsx:95:12" data-component-path="src/app/components/WhyChooseUs.tsx" data-component-line="95" data-component-end-line="118" data-component-file="WhyChooseUs.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22why-card%20step-card%20group%22%7D"
              key={reason.title}
              className="why-card step-card group"
              style={{
                opacity: 0,
                transform: 'translateY(30px)',
                transition: 'opacity 0.8s cubic-bezier(0.16,1,0.3,1), transform 0.8s cubic-bezier(0.16,1,0.3,1)',
              }}
            >
              <div data-component-id="src/app/components/WhyChooseUs.tsx:104:14" data-component-path="src/app/components/WhyChooseUs.tsx" data-component-line="104" data-component-end-line="111" data-component-file="WhyChooseUs.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-start%20gap-4%20mb-4%22%7D" className="flex items-start gap-4 mb-4">
                {/* <div className="w-11 h-11 rounded-xl bg-primary/8 flex items-center justify-center shrink-0 group-hover:bg-primary/15 transition-colors duration-300">
                  <Icon name={reason.icon as any} size={20} className="text-primary" />
                </div>
                <span className="text-xs font-semibold text-muted-foreground mt-2 tracking-widest">
                  Est. {reason.year}
                </span>*/}
              </div>
              <h3 data-component-id="src/app/components/WhyChooseUs.tsx:112:14" data-component-path="src/app/components/WhyChooseUs.tsx" data-component-line="112" data-component-end-line="114" data-component-file="WhyChooseUs.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22font-semibold%20text-foreground%20text-base%20mb-2%22%7D" className="font-semibold text-foreground text-base mb-2">
                {reason.title}
              </h3>
              <p data-component-id="src/app/components/WhyChooseUs.tsx:115:14" data-component-path="src/app/components/WhyChooseUs.tsx" data-component-line="115" data-component-end-line="117" data-component-file="WhyChooseUs.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-muted-foreground%20leading-relaxed%22%7D" className="text-sm text-muted-foreground leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}